module.exports = __webpack_public_path__ + "static/img/gfbk4.bc183fc5.png";